import { render, staticRenderFns } from "./HeavenUserDataImport.vue?vue&type=template&id=c6ef1d8c&"
import script from "./HeavenUserDataImport.vue?vue&type=script&lang=js&"
export * from "./HeavenUserDataImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports